// extracted by mini-css-extract-plugin
module.exports = {"container":"BgLoading_container_RyxvY","fading":"BgLoading_fading_38lcs"};